import { useRef, useState } from 'react';
import { Row } from '_Elements/layout';
import { SVGLogo } from '_Icons';
import { H, HEADING_SIZES } from '_Elements/text/v2';
import { P, PARAGRAPH_SIZES } from '_Elements/text/v2';
import { Button, BUTTON_THEME } from '_Elements/button/v2';

const MagicLinkConfirm = (props) => {
  const { token, return_to, authenticity_token, messages } = props;

  // The token is consumed only by this POST. A visible click is required on
  // purpose: email scanners issue GETs and never submit the form, so their
  // prefetch cannot burn the link. Do not auto-submit.
  const submitRef = useRef();

  // The server enforces one-time use; this only avoids a confusing double submit.
  const [submitting, setSubmitting] = useState(false);

  const onLogin = () => {
    if (submitting) return;
    setSubmitting(true);
    submitRef.current.click();
  };

  return (
    <div data-component={'magic-link-confirm'}>
      <Row center>
        <SVGLogo size={64} />
      </Row>
      <Row center style={{ marginBlockStart: 40 }}>
        <H textSize={HEADING_SIZES.H5}>{messages['magic_link_confirm_title']}</H>
      </Row>
      <Row center style={{ marginBlockStart: 24 }}>
        <P textSize={PARAGRAPH_SIZES.P1}>{messages['magic_link_confirm_body']}</P>
      </Row>
      <Row center style={{ marginBlockStart: 40 }}>
        <Button
          rounded
          theme={BUTTON_THEME.PRIMARY}
          onClick={onLogin}
          loading={submitting}
          data-cy={'magic-link-confirm__login'}
        >
          {messages['magic_link_confirm_button']}
        </Button>
      </Row>
      <form style={{ display: 'none' }} method={'post'} action={'/magic_link_login'}>
        <input type={'hidden'} name={'authenticity_token'} value={authenticity_token} />
        <input type={'hidden'} name={'token'} value={token} />
        {return_to && <input type={'hidden'} name={'return_to'} value={return_to} />}
        <button type={'submit'} ref={submitRef} />
      </form>
    </div>
  );
};

export default MagicLinkConfirm;
